<template>
  <div class="das-form-avatar-container">
    <div class="img-containber-box">
      <div class="img-container mb-10">
        <img ref="img" :src="imgSrc" />
      </div>
      <input
        :id="id"
        ref="file"
        type="file"
        style="display: none"
        @change="onSelectFile"
      />
      <label v-if="isEditMode" class="upload-title" :for="id"
        >Tải ảnh lên</label
      >
    </div>
  </div>
</template>

<script>
import { emptyImgX64 } from './data/data'
export default {
  props: {
    isEditMode: {
      default: false,
      type: Boolean
    },
    imgSrc: {
      default: null,
      type: String
    }
  },
  data() {
    return {
      id: `id-${Math.floor(Math.random() * 1000)}`,
      isHasImgSource: false
    }
  },
  watch: {
    imgSrc(value) {
      if (!value) {
        this.onResetImgSrc()
      }
    }
  },
  mounted() {
    if (!this.imgSrc) {
      this.onResetImgSrc()
    }
  },
  methods: {
    onSelectFile(event) {
      this.isHasImgSource = true
      this.$refs.img.src = URL.createObjectURL(event.target.files[0])
      this.$emit('fileChanged', event.target.files[0])
    },
    onResetImgSrc() {
      this.$refs.img.src = emptyImgX64
      this.$refs.file = null
    },
    onSetImgSrc(source) {
      if (source) {
        this.$refs.img.src = source
      }
    }
  }
}
</script>
<style lang="scss" scoped>
img {
  visibility: hidden;
}

img[src] {
  visibility: visible;
}
</style>
